import { MutationFunctionOptions, MutationHookOptions, MutationResult } from "@apollo/client";
import { useMutation } from "../../../hooks";
import { FetchResult } from "@apollo/client/link/core";
import { Assumption } from "@design-system";
import { replaceInMatterAssumptionsCache } from "../../query";
import { graphql } from "~/gql";
import {
  UpdateAssumptionMutation,
  UpdateAssumptionMutationVariables,
  UpdateAssumptionsMutationVariables,
} from "~/gql/graphql";

export const UPDATE_ASSUMPTION = graphql(/* GraphQL */ `
  mutation updateAssumption($input: [UpdateManyAssumptionsInput!]!) {
    updateAssumption(input: $input) {
      id
      text
      order
      createdAt
      updatedAt
      matterId
    }
  }
`);

export const UPDATE_ASSUMPTIONS = graphql(/* GraphQL */ `
  mutation updateAssumptions($input: [UpdateManyAssumptionsInput!]!) {
    updateAssumptions(input: $input) {
      id
      text
      order
    }
  }
`);

export type UpdateAssumptionMutationFunction = (
  matterId: number,
  assumption: Assumption,
  options?: MutationFunctionOptions<UpdateAssumptionMutation, UpdateAssumptionsMutationVariables>
) => Promise<FetchResult<UpdateAssumptionMutation>>;

export function useUpdateAssumptionMutation(
  options?: MutationHookOptions<UpdateAssumptionMutation, UpdateAssumptionMutationVariables>
): [UpdateAssumptionMutationFunction, MutationResult<UpdateAssumptionMutation>] {
  const [mutationFunction, mutationResult] = useMutation(UPDATE_ASSUMPTION, {
    errorPolicy: "none",
    ...(options || {}),
  });
  const updateAssumptionMutation: UpdateAssumptionMutationFunction = (
    matterId,
    assumption,
    options
  ) => {
    const { id, text, fromLibraryAssumptionId } = assumption;
    return mutationFunction({
      variables: {
        input: [
          {
            id: id!,
            payload: {
              text: {
                set: text,
              },
              fromLibraryAssumption: {
                disconnect: {},
                ...(fromLibraryAssumptionId
                  ? {
                      connect: {
                        id: fromLibraryAssumptionId,
                      },
                    }
                  : {
                      disconnect: {},
                    }),
              },
            },
          },
        ],
      },
      update(cache, { data }) {
        replaceInMatterAssumptionsCache(cache, matterId, data?.updateAssumption!);
      },
      ...(options || {}),
    });
  };
  return [updateAssumptionMutation, mutationResult];
}
